export async function processPendingBankSettlements(supabase, organizationId) {
  if (!organizationId) return { processed: 0 };

  const nowIso = new Date().toISOString();

  const { data: pendingMovements, error } = await supabase
    .from('movimientos_financieros')
    .select('id, bank_id, tipo, monto, fecha_operacion')
    .eq('organization_id', organizationId)
    .not('bank_id', 'is', null)
    .is('saldo_resultante', null)
    .neq('is_active', false)
    .lte('fecha_operacion', nowIso)
    .order('fecha_operacion', { ascending: true });

  if (error) throw error;

  let processed = 0;

  for (const movement of pendingMovements || []) {
    const amount = Number(movement?.monto || 0);
    if (!movement?.bank_id || amount <= 0) continue;

    // Acreditación ATÓMICA y race-free: el RPC toma un lock de la fila del
    // movimiento, aplica el delta al banco y setea saldo_resultante en una sola
    // transacción. Antes, esta función (que corre en paralelo en 4 páginas) hacía
    // read-modify-write y podía acreditar dos veces el mismo movimiento. Bug T1.
    const { error: settleError } = await supabase.rpc('settle_bank_movement', {
      p_movement_id: movement.id,
    });

    if (settleError) throw settleError;

    processed += 1;
  }

  return { processed };
}
